import { Button, Col, Form, Input, Row, Select, Table, Typography } from 'antd';
import { Option } from 'antd/es/mentions';
import { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SelectClientsOnly } from '../../../../components/common/FormItem/SelectCustomFeilds';
import { useLazyGetClientGdsSignatureQuery } from '../../AirlineWiseSalesReport/endpoints/AirlineWiseSalesReportEndpoints';
import { IAirTicketSummary } from '../Interfaces/AirTicketReport.interfaces';

const ClientGdsSignature = () => {
  const [form] = Form.useForm();
  const [fetchDATA, { data, isLoading }] = useLazyGetClientGdsSignatureQuery();
  const [page, setPage] = useState(1);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(100);
  const [searchParams, setSearchParams] = useSearchParams();
  const onFinish = (values: any) => {
    const { date, gds_name, search, clientId } = values;
    const filterData: any = {
      page: currentPage,
      limit: pageSize,
    };

    const params: any = {};
    if (clientId) {
      filterData.clientId = clientId;
      params.clientId = clientId;
    }
    if (search) {
      filterData.search = search;
      params.search = search;
    }
    if (gds_name) {
      filterData.gds_name = gds_name;
      params.gds_name = gds_name;
    }
    if (date?.length) {
      filterData.from_date = dayjs(date[0]).format('YYYY-MM-DD');
      filterData.to_date = dayjs(date[1]).format('YYYY-MM-DD');
      params.from_date = filterData.from_date;
      params.to_date = filterData.to_date;
    }

    params.page = currentPage;
    params.limit = pageSize;

    setSearchParams(params); // updates URL
    fetchDATA(filterData);
  };
  useEffect(() => {
    const from_date = searchParams.get('from_date');
    const to_date = searchParams.get('to_date');
    const pageParam = Number(searchParams.get('page') || 1);
    const limitParam = Number(searchParams.get('limit') || 100);
    const search = searchParams.get('search');
    const gds_name = searchParams.get('gds_name');
    const clientId = searchParams.get('clientId');

    const initValues: any = {};
    if (search) initValues.search = search;
    if (gds_name) initValues.gds_name = gds_name;
    if (clientId) initValues.clientId = clientId;

    if (from_date && to_date) {
      initValues.date = [dayjs(from_date), dayjs(to_date)];
    } else {
      initValues.date = [dayjs(), dayjs()];
    }

    form.setFieldsValue(initValues);

    setPage(pageParam);
    setPageSize(limitParam);
    setCurrentPage(pageParam);

    // Automatically trigger form submission with prefilled values
    form.submit();
  }, []);

  const AirTicketSummaryColv2 = (): ColumnsType<IAirTicketSummary> => [
    {
      title: 'SL',
      render: (_text, _record, index) => (page - 1) * pageSize + index + 1,
      width: 60,
      align: 'center',
    },
    {
      title: (
        <>
          <p className='table-column-title'>Client Name</p>
        </>
      ),
      render: (record) => (
        <>
          {record.client_name}
          {' - '}
          {record.client_type}
        </>
      ),
    },
    {
      title: (
        <>
          <p className='table-column-title'>GDS Name</p>
        </>
      ),
      render: (record) => <p>{record?.gds_name}</p>,
    },

    {
      title: 'EPR',
      render: (record) => <p>{record?.gds_epr}</p>,
    },
    {
      title: 'Sign',
      render: (record) => <p>{record?.gds_creation_sign}</p>,
    },

    {
      title: 'Created By',
      render: (record) => <p>{record?.sign_created_by}</p>,
    },
  ];

  return (
    <div>
      <Typography.Title level={3} style={{ margin: '5px 5px' }}>
        Client GDS Signature{' '}
      </Typography.Title>
      <Form
        onFinish={onFinish}
        layout='vertical'
        form={form}
        initialValues={{ date: [dayjs(), dayjs()] }}
      >
        <Row gutter={[5, 2]} align='middle'>
          <SelectClientsOnly
            name='clientId'
            size={4}
            label='Select Client'
            placeholder='Select Client'
            offDropDown
          />
          <Col span={6} xs={24} sm={24} md={4} lg={4}>
            <Form.Item label='Search by GDS' name='gds_name'>
              <Select allowClear placeholder='Search BY GDS'>
                <Option value='Sabre'>Sabre</Option>
                <Option value='Amadeus'>Amadeus</Option>
                <Option value='Galileo'>Galileo</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={6} xs={24} sm={24} md={4} lg={4}>
            <Form.Item label='Search by EPR OR Sign' name='search'>
              <Input placeholder='Search BY EPR OR Sign' allowClear />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={24} lg={6} xl={3} xxl={2}>
            <Form.Item>
              <Button
                type='primary'
                htmlType='submit'
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  marginTop: '28px',
                }}
              >
                Search
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
        <Typography.Text>You have total: {data?.count} rows</Typography.Text>
      </div>

      <Table
        size='small'
        bordered
        rowKey='invoice_id'
        dataSource={data?.data || []}
        columns={AirTicketSummaryColv2()}
        scroll={{ x: 'max-content' }}
        loading={isLoading}
        pagination={{
          total: data?.count || 0,
          current: page,
          pageSize: pageSize,
          showSizeChanger: true,
          pageSizeOptions: ['100', '200', '500'],
          onChange: (newPage, newPageSize) => {
            setPage(newPage);
            setPageSize(newPageSize);
            setCurrentPage(newPage);
            form.submit(); // triggers onFinish and URL update
          },
        }}
      />
    </div>
  );
};

export default ClientGdsSignature;
